// imports
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../..';
import {
  Quest, Trait, World, BackpackItem
} from '../../../../common/types';
import { fetchConfig as fetchConfigThunk } from '../../thunks';

// interfaces / types / consts
interface Traits { [key: string]: Trait }
interface Quests { [key: string]: Quest }
interface Backpack { [key: string]: BackpackItem }
interface Texts { [key: string]: { title: string; body: string } }

// redux slice
const configSlice = createSlice({
  name: 'config',
  initialState: {
    fetctError: '',
    fetchStatus: 'idle',
    world: {} as World,
    texts: {} as Texts,
    traits: {} as Traits,
    quests: {} as Quests,
    items: {} as Backpack
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchConfigThunk.pending, (state) => {
      state.fetctError = '';
      state.fetchStatus = 'loading';
    });
    builder.addCase(fetchConfigThunk.fulfilled, (state, action) => {
      state.fetctError = '';
      state.fetchStatus = 'success';
      state.items = action.payload.items;
      state.world = action.payload.world;
      state.traits = action.payload.traits;
      state.quests = action.payload.quests;
      state.texts = action.payload.genericTexts;
    });
    builder.addCase(fetchConfigThunk.rejected, (state, action) => {
      state.fetchStatus = 'error';
      state.fetctError = action.payload as string;
    });
  }
});

// exports
export const selectConfig = (state: RootState): typeof state.config => state.config;
export default configSlice.reducer;
